import { FfmpegSettingsSchema } from './schemas/settingsSchemas.js';
export const defaultFfmpegSettings = FfmpegSettingsSchema.parse({});
//# sourceMappingURL=FfmpegSettings.js.map